'use strict';
/*!
 * Read more button.
 *
 * @package tokai-univ
 * @deps tokai-univ-newsentry, jquery
 */

const $ = jQuery;

$( '#read-more' ).click( function ( e ) {
	e.preventDefault();
	const $button = $( this );
	$button.attr( 'disabled', true ).blur();
	const url = $button.attr( 'data-href' );
	const $list = $( '.news-entry-list' );
	$list.addClass( 'loading' );
	$.get( url ).done( res => {
		// Parser HTML.
		if ( ! res.match( /<!-- \.news-entry-list \/\/ -->([\s\S]*)<!-- \/\/ \.news-entry-list -->/ ) ) {
			$( this ).remove();
			return;
		}
		const $newItems = $( '<ul>' + RegExp.$1 + '</ul>' );
		$newItems.find( '> li' ).each( ( index, item ) => {
			$list.append( item );
			$list.masonry( 'appended', item );
		} );
		$list.masonry( {
			itemSelector: '.js-masonry-item',
			horizontalOrder: true,
			gutter: 20,
			percentPosition: true,
		} );
		// Replace button href.
		if ( res.match( /<button id="read-more" data-href="([^"]*)"/ ) ) {
			$( this ).attr( 'data-href', RegExp.$1 ).attr( 'disabled', null );
		} else {
			$( this ).remove();
		}
	} ).fail( () => {
		$( this ).remove();
	} ).always( () => {
		$list.removeClass( 'loading' );
	} );
} );
